import React from 'react';
import { motion } from 'framer-motion';
import { Moon } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-24 px-6 bg-white relative" data-id="element-112">
      <div className="max-w-3xl mx-auto text-center" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex justify-center mb-8" data-id="element-114">
          <div className="w-16 h-16 bg-brand-blueLight rounded-full flex items-center justify-center text-brand-blue" data-id="element-115">
            <Moon size={32} strokeWidth={1.5} data-id="element-116" />
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-xl md:text-2xl leading-relaxed text-brand-text mb-10 font-serif italic" data-id="element-117">
          "Son las 2 de la mañana. Estás de pie en la oscuridad, meciendo a tu
          bebé con los brazos adoloridos y el corazón acelerado. Sientes que has
          probado todo, pero en cuanto intentas dejarlo en la cuna, sus ojos se
          abren de golpe y el llanto vuelve a empezar."
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-brand-cream p-8 rounded-2xl border border-brand-brown/10" data-id="element-118">
          <p className="text-lg md:text-xl text-brand-brown font-medium leading-relaxed" data-id="element-119">
            No eres un mal padre. No tienes un "bebé difícil".{' '}
            <br className="hidden md:block" data-id="element-120" />
            <span className="font-bold" data-id="element-121">
              Simplemente estás operando con un sistema nervioso que está
              atrapado en modo alerta.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}